import { render, staticRenderFns } from "./SelectedCoin.vue?vue&type=template&id=18045466&scoped=true&"
import script from "./SelectedCoin.vue?vue&type=script&lang=ts&"
export * from "./SelectedCoin.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedCoin.vue?vue&type=style&index=0&id=18045466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18045466",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
